import { useEffect, useState } from "react";
import { getDashboard } from "../api/traceabilityApi";

export function useTraceabilityDashboard(commodity) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    setLoading(true);
    getDashboard(commodity)
      .then((d) => live && (setData(d), setError(null)))
      .catch((e) => live && setError(e))
      .finally(() => live && setLoading(false));
    return () => {
      live = false;
    };
  }, [commodity]);

  return { data, loading, error };
}
